module.exports = __webpack_public_path__ + "static/media/biometria-dactilar.01583e72.jpg";